import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  DoCheck,
  ViewChild,
} from '@angular/core';
import { storageUtil } from 'src/app/utils';
import {
  StudentService,
} from 'src/app/services';
import { BrowserService, CryptoService } from 'src/app/core';
import { API_CONSTANTS, BENEFIT_NEWSLETTER, COLLEGE_RECON_CONSTANTS } from 'src/app/constants';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data-link.service';
import { Sidebar } from 'primeng/sidebar';
import { groupBy, filter, debounce } from 'src/app/utils/lodash-utility';

@Component({
  selector: 'student-layout',
  templateUrl: './student-layout.component.html',
})
export class StudentLayoutComponent implements OnInit, OnDestroy, DoCheck {
  // Sidebar click
  sidebarVisible: boolean = false;
  resizeListener: any;
  pathname!: string;
  API_CONSTANT = API_CONSTANTS;
  newsletterModal = false;
  newsletters: any[] = [];


  closeCallback(): void {
    this.sidebarVisible = false;
    if (window.screen.width > 1200) {
      this.sidebarVisible = false;
    }
  }

  user: any;
  isBrowser: any;
  private studentProfileSubscription$!: Subscription;

  constructor(
    private _storageUtil: storageUtil,
    private _cryptoService: CryptoService,
    private _studentService: StudentService,
    private _dataLinkService: DataService,
    private _browserService: BrowserService,
  ) {}

  ngDoCheck() {
    this.isBrowser = this._browserService.checkBrowser();
    if (this.isBrowser) {
      const urlData = window.location.href.split('/');
      this.pathname = urlData[urlData.length - 1];
    }
  }

  ngOnInit(): void {
    this.newsletters = BENEFIT_NEWSLETTER;
    this.isBrowser = this._browserService.checkBrowser();
    this.checkScreenWidth();

    this.resizeListener = debounce(() => {
      this.checkScreenWidth();
    }, 200);
    if (this.isBrowser) {
      const encryptedData = this._storageUtil.getItem('loggedInUser');
      this.user =
        encryptedData &&
        this._cryptoService.decryptData(
          encryptedData,
          COLLEGE_RECON_CONSTANTS.userEncryptDecryptSecretKey,
        );
      this.user = JSON.parse(this.user);
      this._dataLinkService.setUser(this.user);

      this.getBannerInfo();
      this.getInboxCount();
    }
  }

  ngOnDestroy(): void {
    this.studentProfileSubscription$.unsubscribe();
    this.isBrowser && window.removeEventListener('resize', this.resizeListener);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.checkScreenWidth();
  }

  checkScreenWidth(): void {
    if (this.isBrowser && window.screen.width > 1200) {
      this.sidebarVisible = true;
    } else this.sidebarVisible = false;

    if(this.isBrowser && window.innerWidth <1200) {
      this.sidebarVisible = false;
    }
  }

  onMenuToggle() {
    this.sidebarVisible = true;
  }

  getBannerInfo() {
    this.studentProfileSubscription$ = this._studentService
      .getBannerInfo(this.user.userId)
      .subscribe((veteranInfo) => {
        veteranInfo.militaryInfo = [
          veteranInfo.militaryRankName ? veteranInfo.militaryRankName : null,
          veteranInfo.branchName ? veteranInfo.branchName : null,
        ]
          .filter(Boolean)
          .join(', ');
        this._dataLinkService.setVeteranInfo(veteranInfo);
      });
  }

  getInboxCount() {
    this._studentService.getInboxMessageCount(this.user.userId).subscribe({
      next: (res) => {
        this._dataLinkService.setInboxCount(res.countinbox);
      },
      error: (e) => console.log(e),
    });
  }

  
  view(url: string) {
    if (url && this.isBrowser) window.open(url, '_blank','noopener,noreferrer');
  }

}
